import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["name", "containerTypes", "contentIds", "simpleCtaOnly"];
import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';
/**
 * GET web-interactives/v1/cos-interactives/{id}
 * @param {number} id Call to action id
 * @param [httpClient] httpClient - optional custom http client
 * @returns {Promise} fetch call to action by id
 */
export function fetchWebInteractive(id, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get(`web-interactives/v1/cos-interactives/${id}`);
}
const createCrmFilters = ({
  containerTypes,
  contentIds,
  simpleCtaOnly
}) => {
  const filters = [{
    operator: 'IN',
    property: 'hs_publish_state',
    values: ['PUBLISHED', 'PUBLISHED_OR_SCHEDULED']
  }, {
    operator: 'EQ',
    property: 'hs_is_archived',
    value: false
  }];
  if (containerTypes) {
    filters.push({
      operator: 'IN',
      property: 'hs_container_type',
      values: containerTypes
    });
  }
  if (contentIds) {
    filters.push({
      operator: 'IN',
      property: 'hs_content_id',
      values: contentIds
    });
  }
  if (simpleCtaOnly) {
    filters.push({
      operator: 'EQ',
      property: 'hs_is_simple_cta',
      value: true
    });
  }
  return filters;
};

/**
 * POST /crm-search/search
 * @param {object} query Query params
 * @param [httpClient] httpClient - optional custom http client
 * @returns {Promise} fetch all calls to action from framework (paginated)
 */
export function fetchWebInteractives(_ref, ...rest) {
  let {
      name,
      containerTypes,
      contentIds,
      simpleCtaOnly
    } = _ref,
    query = _objectWithoutPropertiesLoose(_ref, _excluded);
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.post('crm-search/search', {
    data: Object.assign({
      filterGroups: [{
        filters: createCrmFilters({
          containerTypes,
          contentIds,
          simpleCtaOnly
        })
      }],
      objectTypeId: '0-91',
      requestOptions: {
        allPropertiesFetchMode: 'latest_version',
        includeAllProperties: true
      },
      query: name,
      sorts: [{
        property: 'hs_updated_at',
        order: 'DESC'
      }]
    }, query)
  });
}
let hasPublishedWebInteractive = null;
export function getHasPublishedWebInteractive(...rest) {
  if (hasPublishedWebInteractive !== null) return Promise.resolve(hasPublishedWebInteractive);
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('web-interactives/v1/cos-interactives', {
    query: {
      limit: 1,
      state__in: ['PUBLISHED_OR_SCHEDULED', 'PUBLISHED'],
      orderBy: 'updated'
    }
  }).then(response => {
    hasPublishedWebInteractive = response.objects.length > 0;
    return hasPublishedWebInteractive;
  });
}